import Axios, { AxiosInstance, AxiosPromise, AxiosResponse, AxiosBasicCredentials, AxiosRequestConfig } from "axios";
import Qs from "qs";
/* eslint-disable */

export enum CacheStategy {
  NetworkFirst,
  CacheFirst,
  None
}


/// ----------------------------------------------------------------------------  ///
///                                 ATTENZIONE                                    ///
///            VIETATO APPORTARE QUALSIASI MODIFICA A QUESTO METODO O CLASSE      ///
/// ----------------------------------------------------------------------------  ///
export class baseRestService {

  protected allwaysSendAuthenticationToken: boolean = true;
  protected saveToSessionStorage: boolean = true;
  baseUrl: () => string = () => process.env.VUE_APP_BASE_API;

  OnError?: OnErrorDelegate;
  OnHeadersPreparing?: OnHeadersPreparingDelegate;

  protected http: AxiosInstance;

  /// ----------------------------------------------------------------------------  ///
  ///                                 ATTENZIONE                                    ///
  ///            VIETATO APPORTARE QUALSIASI MODIFICA A QUESTO METODO O CLASSE      ///
  /// ----------------------------------------------------------------------------  ///
  constructor() {
    this.http = Axios.create();
    this.setArraySerializationMethod();
  }


  /// ----------------------------------------------------------------------------  ///
  ///                                 ATTENZIONE                                    ///
  ///            VIETATO APPORTARE QUALSIASI MODIFICA A QUESTO METODO O CLASSE      ///
  /// ----------------------------------------------------------------------------  ///
  private setArraySerializationMethod() {
    this.http.interceptors.request.use(async (reqConfig) => {
      //change the default serializer only if the method is a GET
      if (reqConfig.method !== "get") {
        return reqConfig;
      }
      //the 'repeat' is the standard behavior for array: arrKey=x&arrKey=y&arrKey=z....
      reqConfig.paramsSerializer = (params) => {
        return Qs.stringify(params, { arrayFormat: "repeat" });
      };
      return reqConfig;
    });
  }

  /// ----------------------------------------------------------------------------  ///
  ///                                 ATTENZIONE                                    ///
  ///            VIETATO APPORTARE QUALSIASI MODIFICA A QUESTO METODO O CLASSE      ///
  /// ----------------------------------------------------------------------------  ///
  protected async getRaw(uri: string, params: object = {}, sendAuthenticationToken: boolean = false, cacheStrategy: CacheStategy = CacheStategy.None): Promise<AxiosResponse> {

    let response = await this.http.get(this.baseUrl() + uri,
      {
        headers: await this.prepareHeaders(this.allwaysSendAuthenticationToken || sendAuthenticationToken, false, cacheStrategy),
        params: params,
        responseType: 'arraybuffer'
      });

    if (response.status != 200 && this.OnError) this.OnError(response);
    return response;
  };

  /// ----------------------------------------------------------------------------  ///
  ///                                 ATTENZIONE                                    ///
  ///            VIETATO APPORTARE QUALSIASI MODIFICA A QUESTO METODO O CLASSE      ///
  /// ----------------------------------------------------------------------------  ///
  protected async get(uri: string, params: object = {}, sendAuthenticationToken: boolean = false, cacheStrategy: CacheStategy = CacheStategy.NetworkFirst): Promise<AxiosResponse> {
    let response = await this.http.get(this.baseUrl() + uri,
      {
        headers: await this.prepareHeaders(this.allwaysSendAuthenticationToken || sendAuthenticationToken, false, cacheStrategy),
        params: params,
        transformResponse: transformResponse
      });

    if (response.status != 200 && this.OnError) this.OnError(response);
    return response;
  };

  /// ----------------------------------------------------------------------------  ///
  ///                                 ATTENZIONE                                    ///
  ///            VIETATO APPORTARE QUALSIASI MODIFICA A QUESTO METODO O CLASSE      ///
  /// ----------------------------------------------------------------------------  ///
  protected async Get<TResult>(uri: string, params: object = {}, sendAuthenticationToken: boolean = false, cacheStrategy: CacheStategy = CacheStategy.NetworkFirst): Promise<TResult | null> {
    let result = await this.get(uri, params, sendAuthenticationToken, cacheStrategy);
    if (result.status == 200)
      return result.data as TResult;
    else if (this.OnError) this.OnError(result);
    return null;
  }

  /// ----------------------------------------------------------------------------  ///
  ///                                 ATTENZIONE                                    ///
  ///            VIETATO APPORTARE QUALSIASI MODIFICA A QUESTO METODO O CLASSE      ///
  /// ----------------------------------------------------------------------------  ///
  protected async post(uri: string, data: any, params: object = {}, sendAuthenticationToken: boolean = false, cacheStrategy: CacheStategy = CacheStategy.None): Promise<AxiosResponse> {
    let response = await this.http.post(this.baseUrl() + uri, data,
      {
        headers: await this.prepareHeaders(this.allwaysSendAuthenticationToken || sendAuthenticationToken, false, cacheStrategy),
        params: params,
        transformResponse: transformResponse
      } as AxiosRequestConfig);

    // if (response.status != 200 && this.OnError) this.OnError(response);
    return response;
  };

  /// ----------------------------------------------------------------------------  ///
  ///                                 ATTENZIONE                                    ///
  ///            VIETATO APPORTARE QUALSIASI MODIFICA A QUESTO METODO O CLASSE      ///
  /// ----------------------------------------------------------------------------  ///
  protected async Post<TResult>(uri: string, data: any, params: object = {}, sendAuthenticationToken: boolean = false, cacheStrategy: CacheStategy = CacheStategy.None): Promise<TResult | null> {
    
    let result = await this.post(uri, data, params, sendAuthenticationToken, cacheStrategy);
    if (result.status == 200)
      return result.data as TResult;
    else if (this.OnError) this.OnError(result);
    return null;
  }

  /// ----------------------------------------------------------------------------  ///
  ///                                 ATTENZIONE                                    ///
  ///            VIETATO APPORTARE QUALSIASI MODIFICA A QUESTO METODO O CLASSE      ///
  /// ----------------------------------------------------------------------------  ///
  protected async put(uri: string, data: any, params: object = {}, sendAuthenticationToken: boolean = false, cacheStrategy: CacheStategy = CacheStategy.None): Promise<AxiosResponse> {
    let response = await this.http.put(this.baseUrl() + uri, data,
      {
        headers: await this.prepareHeaders(this.allwaysSendAuthenticationToken || sendAuthenticationToken, true, cacheStrategy),
        params: params,
        transformResponse: transformResponse
      });
    if (response.status != 200 && this.OnError) this.OnError(response);
    return response;
  }

  /// ----------------------------------------------------------------------------  ///
  ///                                 ATTENZIONE                                    ///
  ///            VIETATO APPORTARE QUALSIASI MODIFICA A QUESTO METODO O CLASSE      ///
  /// ----------------------------------------------------------------------------  ///
  protected async Put<TResult>(uri: string, data: any, params: object = {}, sendAuthenticationToken: boolean = false, cacheStrategy: CacheStategy = CacheStategy.None): Promise<TResult | null> {
    let result = await this.put(uri, data, params, sendAuthenticationToken, cacheStrategy);
    if (result.status == 200)
      return result.data as TResult;
    else if (this.OnError) this.OnError(result);
    return null;
  }

  /// ----------------------------------------------------------------------------  ///
  ///                                 ATTENZIONE                                    ///
  ///            VIETATO APPORTARE QUALSIASI MODIFICA A QUESTO METODO O CLASSE      ///
  /// ----------------------------------------------------------------------------  ///
  protected async delete(uri: string, params: object = {}, sendAuthenticationToken: boolean = false, cacheStrategy: CacheStategy = CacheStategy.None): Promise<AxiosResponse> {
    let response = await this.http.delete(this.baseUrl() + uri,
      {
        headers: await this.prepareHeaders(this.allwaysSendAuthenticationToken || sendAuthenticationToken, false, cacheStrategy),
        params: params,
        transformResponse: transformResponse
      });
    if (response.status != 200 && this.OnError) this.OnError(response);
    return response;
  }

  /// ----------------------------------------------------------------------------  ///
  ///                                 ATTENZIONE                                    ///
  ///            VIETATO APPORTARE QUALSIASI MODIFICA A QUESTO METODO O CLASSE      ///
  /// ----------------------------------------------------------------------------  ///
  protected async Delete<TResult>(uri: string, params: object = {}, sendAuthenticationToken: boolean = false, cacheStrategy: CacheStategy = CacheStategy.None): Promise<TResult | null> {
    let result = await this.delete(uri, params, sendAuthenticationToken, cacheStrategy);
    if (result.status == 200)
      return result.data as TResult;
    else if (this.OnError) this.OnError(result);
    return null;
  }

  /// ----------------------------------------------------------------------------  ///
  ///                                 ATTENZIONE                                    ///
  ///            VIETATO APPORTARE QUALSIASI MODIFICA A QUESTO METODO O CLASSE      ///
  /// ----------------------------------------------------------------------------  ///
  protected async prepareHeaders(auth: boolean = false, json: boolean = true, cacheStrategy: CacheStategy = CacheStategy.None): Promise<any> {

    let headers: any = {};
    if (auth) {
      let authData = await this.getAuthenticationToken();
      if (authData) {
        headers['Authorization'] = 'Bearer ' + authData.access_token;
      }
    }
    if (json) headers['Content-Type'] = 'application/json';

    switch (cacheStrategy) {
      case CacheStategy.NetworkFirst: headers['X-Strategy'] = 'networkFirst'; break;
      case CacheStategy.CacheFirst: headers['X-Strategy'] = 'cacheFirst'; break;
      case CacheStategy.None:
      default: break;
    }

    if (this.OnHeadersPreparing) this.OnHeadersPreparing(headers);
    return headers;
  }

  protected static _token: AuthToken | null;

  /// ----------------------------------------------------------------------------  ///
  ///                                 ATTENZIONE                                    ///
  ///            VIETATO APPORTARE QUALSIASI MODIFICA A QUESTO METODO O CLASSE      ///
  /// ----------------------------------------------------------------------------  ///
  protected getAuthenticationToken(): AuthToken {
    return JSON.parse(localStorage.getItem("authorizationData") ||'{}')
  }
}

export interface OnErrorDelegate { (data: DataResponse): void; }
interface OnHeadersPreparingDelegate { (headers: Headers): void; }

/// ----------------------------------------------------------------------------  ///
///                                  ATTENZIONE                                    ///
///            VIETATO APPORTARE QUALSIASI MODIFICA A QUESTO METODO O CLASSE      ///
/// ----------------------------------------------------------------------------  ///
export interface AuthToken {
  access_token: string
  token_type: string
  expires_in: number
  refresh_token: string;
  expiration_date: number;
}

/// ----------------------------------------------------------------------------  ///
///                                 ATTENZIONE                                    ///
///            VIETATO APPORTARE QUALSIASI MODIFICA A QUESTO METODO O CLASSE      ///
/// ----------------------------------------------------------------------------  ///
export interface DataResponse {
  status: number;
  statusText: string;
  data: any;
}


export function transformResponse(resp) {
  if(resp === null || resp === undefined) return null;
  
  try {
    return JSON.parse(resp)
  } catch (e) {
    return resp;
  }
}


// const reISO = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*))(?:Z?|(\+|-)([\d|:]*))?$/;
const reISO = /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+)|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d)|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d)/;
const reMsAjax = /^\/Date\((d|-|.*)\)[\/|\\]$/;

export function toDate(key: string, value: string) {
  if (typeof value === "string") {
    var a = reISO.exec(value);
    if (a) {
      if (value.indexOf("Z") <= 0)
        return new Date(value + "Z");
      else
        return new Date(value);
    }
    a = reMsAjax.exec(value);
    if (a) {
      var b = a[1].split(/[-+,.]/);
      return new Date(b[0] ? +b[0] : 0 - +b[1]);
    }
  }
  return value;
}
